var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.show)?_c('LoginDialogTemplate',{staticClass:"login-to-show-keyfigures-dialog",attrs:{"options":{
      ..._vm.options,
      redirectUrl: _vm.redirectUrl,
    }},scopedSlots:_vm._u([{key:"intro-super-title",fn:function(){return [_vm._v("Få adgang til mere")]},proxy:true},{key:"intro-text",fn:function(){return [_vm._v(" Opret en gratis profil og se over"),_c('br'),_vm._v("30 regnskabs- og nøgletal ")]},proxy:true}],null,false,307270552)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }